export const SAVE_PROJECT_PATH = 'SAVE_PROJECT_PATH';
export const SET_PROJECT_LIST = 'SET_PROJECT_LIST';

export function hypSaveProject(payload: any) {
  return {
    type: 'SAVE_PROJECT_PATH',
    payload,
  };
}

export const hypSetProjectList = (payload: any) => {
  return {
    type: 'SET_PROJECT_LIST',
    payload,
  };
};
